import { __decorate } from "tslib";
import { action, observable, runInAction } from 'mobx';
import isNil from 'lodash/isNil';
const extReg = /(.*)\.([^.]*)$/;
export default class AttachmentFile {
    constructor(file) {
        runInAction(() => {
            this.name = '';
            this.filename = '';
            this.size = 0;
            this.type = '';
            this.uid = '';
            this.creationDate = new Date();
            this.load(file);
        });
    }
    load(file) {
        const { name } = file;
        if (name) {
            const matches = name.match(extReg);
            if (matches && matches.length > 2) {
                this.ext = matches[2] ? matches[2].toLowerCase() : '';
                this.filename = matches[1];
            }
            else {
                this.ext = '';
                this.filename = name;
            }
        }
        Object.keys(file).forEach(key => {
            const value = file[key];
            if (!isNil(value)) {
                switch (key) {
                    case 'uid':
                        this.uid = String(value);
                        break;
                    default:
                        this[key] = value;
                }
            }
        });
    }
}
__decorate([
    observable
], AttachmentFile.prototype, "name", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "size", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "url", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "filename", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "ext", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "status", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "percent", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "error", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "errorMessage", void 0);
__decorate([
    observable
], AttachmentFile.prototype, "invalid", void 0);
__decorate([
    action
], AttachmentFile.prototype, "load", null);
